import store from '../../store';
import LayoutPrimary from './LayoutPrimary.vue';
import LayoutAlternative from './LayoutAlternative.vue';

const LayoutPool = { LayoutPrimary, LayoutAlternative };
const { [`Layout${store.state.theme.mainLayout}`]: Layout } = LayoutPool;

export default Layout;
